








import { Vue, Component, Prop } from 'nuxt-property-decorator';
import { BlokContentMap } from '../../types';
import Map from '@/components/elements/Map';

@Component({
  components: { Map }
})
export default class ContentMap extends Vue {
  @Prop() blok: BlokContentMap;
}
